export default {
  units: 'الوحدات',
  unit: 'الوحدة',
  add: 'إضافة وحدة',
  update: 'تعديل الوحدة',
  details: 'تفاصيل الوحدة'
}
